export default __webpack_public_path__ + "static/media/littlecreacher_.82cfb6aa.jpeg";